const Logos = [
  { img: "E-commerce" },
  { img: "Retail" },
  { img: "Healthcare" },
  { img: "Education" },
  { img: "Finance" },
  { img: "Logistics" },
  { img: "Real Estate" },
  { img: "Travel & Tourism" },
  { img: "Hospitality" },
  { img: "Insurance" },
  { img: "Telecom" },
  { img: "Food & Beverages" },
  { img: "Automotive" },
  { img: "Media & Entertainment" },
  { img: "Nonprofits & NGOs" },
  { img: "Government Services" },
  { img: "Agriculture" },
  { img: "Utilities" },
  { img: "Fashion & Lifestyle" },
  { img: "Manufacturing" },
];
export default Logos;
